import React, { useState, useEffect } from 'react'
import { generatePublicUrl } from '../../urlConfig'
import SettingIconBlock from '../../components/Button/SettingIconBlock';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import { deleteOrderProductById } from '../../actions';
import ContainerModalConfirmPlusIcon from './../Orders/ContainerModalConfirmPlusIcon';
import Loader from '../../components/Loader';

const RenderProductOrder = ({
    handleShowSettingModal,
    orderDetails,
    productItem,
}) => {
    console.log("productItem", productItem)
    const [completelyFilled, setCompletelyFilled] = useState(false)
    const [showDeletingProduct, setShowDeletingProduct] = useState(false)
    const prI = productItem.productId

    const dispatch = useDispatch()

    useEffect(() => {
        if (orderDetails.height !== undefined
            && orderDetails.height !== undefined
            && orderDetails.width !== undefined
            && orderDetails.bayerPrice !== undefined
            && orderDetails.typeProductColor !== undefined
        ) {
            setCompletelyFilled(true)
        } else {
            setCompletelyFilled(false)
        }
    }, [orderDetails])


    const confirmDelete = (id) => {
        const payload = {
            productOrderDetailsId: prI._id,
            orderId: orderDetails._id,
            fullNameProduct: prI.fullName !== "" ? prI.fullName : "Не указано"
        }
        console.log("payload", payload)
        dispatch(deleteOrderProductById(payload))
    }

    const itemsData = [
        {
            title: "Артикул",
            obj: <div className="renderProductOrder__name">
                <a href='#'>
                    {prI.fullName !== "" ? prI.fullName : "Не указано"}
                </a>
            </div>
        },
        {
            title: "Цена с описания за 1шт",
            obj: <SettingIconBlock
                color="black"
                tooltip="Цена товара"
                children={<div className="renderProductOrder__visibilityPrice">
                    {prI.visibilityPrice === "admin" || prI.visibilityPrice === "public" ? prI.price + " $" : "Нет цены"}
                </div>}
            />
        },
        {
            title: "Цена для покупателя за 1шт",
            obj: productItem.bayerPrice > 0
                ? <div className="renderProductOrder__priceValue">
                    {productItem.bayerPrice} ₽
                </div>
                : <div className="renderProductOrder__noPriceValue">
                    Не указано
                </div>
        },
        {
            title: "Кол-во",
            obj: <div className="renderProductOrder__quantityValue">{productItem.purchasedQty} шт</div>
        },
    ]
    if (!orderDetails) return <Loader />

    return (
        <>
            <div className={`renderProductOrder ${completelyFilled && "completelyFilled"}`} key={prI._id}
                onClick={e => e.stopPropagation()}
            >
                <div className='renderProductOrder__imgBox'>
                    {prI?.productPictures?.length > 0 ? (
                        <img src={generatePublicUrl(prI.productPictures[0].img)} alt={prI?.name || "Изображение"} />
                    ) : (
                        <div className="renderProductOrder__noImage">Нет изображения</div>
                    )}
                </div>
                <div className="renderProductOrder__row">

                    {itemsData.map((data, index) => (
                        <div className="renderProductOrder__itemsDataRow" key={index}>
                            <div className="renderProductOrder__itemsDataRow__title">
                                {data.title}
                            </div>
                            <div className="renderProductOrder__itemsDataRow__line" />
                            <div className="renderProductOrder__itemsDataRow__obj">
                                {data.obj}
                            </div>
                        </div>
                    ))}
                </div>

                <SettingIconBlock
                    color="black"
                    tooltip="Подробная настройка"
                    right="5px"
                    onClick={() => handleShowSettingModal(productItem)}
                />
                {orderDetails.disableFunctionality ? null : <ContainerModalConfirmPlusIcon
                    color="black"
                    tooltip="Удалить товар с заказа"
                    right="25px"
                    icon={<DeleteIcon />}
                    onClickShow={() => setShowDeletingProduct(true)}
                    title={`Подтвердить удаление товара с заказа ${prI.fullName !== "" ? prI.fullName : "Не указано"}`}
                    description="Если вы продолжите то вернуть его будет невозможно!!!"
                    show={showDeletingProduct}
                    handleClose={() => setShowDeletingProduct(false)}
                    onClick={() => confirmDelete(prI._id)}
                />}
            </div>
        </>
    )
}

export default RenderProductOrder
